import React, { useContext, useReducer, useEffect, useMemo } from 'react'
import useVisibility from '../Utils/isVisible';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Table, { TableHookPro } from '../Table';
import { Box, TextField } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Typography from '@mui/material/Typography';
import { lockedReducer } from '../Utils/reducers';
import ColorButton from '../Buttons/ColorButton';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { IconButton } from '@mui/material';
import MegaAutoComplete from '../Utils/megautocomplete';
import { externalComponent } from '../AppRoutes';
import { api } from '../../services/api';
import toast from 'react-hot-toast';
import { formatCurrency, formatDate } from '../Utils/IntegerOnly';

import { convertDateFormat } from '../Utils/functions';
import { number2dayweek } from '../Utils/dayjsptbrhelper';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const getcolumnsConhecimentos = () => {
    const columns = []
    columns.push({ field: 'Empresa', headerName: 'Empresa', width: 120 })
    columns.push({
        field: 'status', headerName: 'Status', flex: 0.1, width: 100,
        renderCell: ({ row }) => {

            return (
                <Box sx={{ width: '90%' }}>
                    {row.notas_vinculadas.length === 0 ? 'Não vinculado' : 'Vinculado'}
                </Box>
            )
        }
    })
    columns.push({ field: 'NumeroNota', headerName: 'CT-e', width: 60 })

    columns.push({ field: 'Serie', headerName: 'Série', width: 60 })
    columns.push({
        field: 'DataEmissao', headerName: 'Emissão', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.DataEmissao)}
                </Box>
            )
        }
    })

    columns.push({ field: 'DataSaida', headerName: 'Chegada', flex: 0.1, width: 100 })
    columns.push({
        field: 'ValorContabil', headerName: 'Valor', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(row.ValorContabil)}
                </Box>
            )
        }
    })
    columns.push({ field: 'ClienteNFE', headerName: 'Transportadora', flex: 0.1, width: 100 })
    return columns
}

const getcolumnsNotas = (transferNota, state, setState) => {
    const columns = []
    columns.push({ field: 'NumeroNota', headerName: 'Núm. NF', flex: 0.1, width: 100 })
    columns.push({ field: 'ClienteNFE', headerName: 'Cliente', flex: 0.1, width: 100 })
    columns.push({ field: 'Serie', headerName: 'Série', flex: 0.1, width: 100 })
    columns.push({
        field: 'DataEmissao', headerName: 'Emissão', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.DataEmissao)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'DataSaida', headerName: 'Chegada', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.DataSaida)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'ValorContabil', headerName: 'Valor', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(row.ValorContabil)}
                </Box>
            )
        }
    })
    columns.push({ field: 'TransportadoraNFE', headerName: 'Transportadora', flex: 0.1, width: 100 })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 30,
        renderCell: (props) => {
            return (
                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={() => transferNota(props.row, state, setState)}><ArrowCircleRightIcon sx={{ color: '#479760', transform: 'rotate(90deg)' }} className='arrowIcon' /></IconButton>
                </Box>
            )
        }
    })
    return columns
}

const getcolumnsNotasVinculadas = (transferNotaVinculada, state, setState) => {
    const columns = []
    columns.push({ field: 'num_nf', headerName: 'Núm. NF', flex: 0.1, width: 100 })
    columns.push({ field: 'cliente', headerName: 'Cliente', flex: 0.1, width: 100 })
    columns.push({ field: 'serie', headerName: 'Série', flex: 0.1, width: 100 })
    columns.push({
        field: 'emissao', headerName: 'Emissão', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.emissao)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'chegada', headerName: 'Chegada', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatDate(row.chegada)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'valor', headerName: 'Valor', flex: 0.1, width: 100,
        renderCell: ({ row }) => {
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(row.valor)}
                </Box>
            )
        }
    })
    columns.push({ field: 'transportadora', headerName: 'Transportadora', flex: 0.1, width: 100 })
    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 30,
        renderCell: (props) => {
            return (
                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <IconButton onClick={() => transferNotaVinculada(props.row, state, setState)}><ArrowCircleRightIcon sx={{ color: '#a14949', transform: 'rotate(270deg)' }} className='arrowIcon' /></IconButton>
                </Box>
            )
        }
    })
    return columns
}

const getConhecimentos = async (setLoader, setState, state, append = false) => {
    setLoader(true)

    const pagination = state.paginationModel || { page: 0, pageSize: 20 }

    const res = await api.post(`/get_conhecimentos/`, {
        ...state,
        offset: pagination.page * pagination.pageSize,
        limit: pagination.pageSize
    })

    if (res.status === 200) {
        const novosDados = res.data.results || res.data
        setState({
            rowsConhecimento: append ? [...state.rowsConhecimento, ...novosDados] : novosDados,
            rowsReset: append ? [...state.rowsConhecimento, ...novosDados] : novosDados,
            totalConhecimentos: res.data.count,
            next: res.data.next, rowsNotas: []
        })
    }

    setLoader(false)
}


const handlePaginationModelChange = (model, setState, getConhecimentos, setLoader, state) => {
    setState({ paginationModel: model })
    getConhecimentos(setLoader, setState, { ...state, paginationModel: model }, true)
}

const selectStatus = {
    1: {
        "nome": "Vinculado",
        "id": "1",
    },
    2: {
        "nome": "Não vinculado",
        "id": "2",
    },
    3: {
        "nome": "Todos",
        "id": "3",
    }
}

const saveConhecimentos = async (setLoader, setState, state, getConhecimentos) => {

    const body = {
        num_conhecimento: state.numConhecimento,
        notas: state.rowsNotasVinculadas
    }

    if (state.rowsNotasVinculadas.length !== 0) {
        setLoader(true)
        const res = await api.post(`/conhecimentos/`, body)
        if (res.status === 200) {
            toast.success('Notas vinculadas salvas com sucesso !')
            getConhecimentos(setLoader, setState, state)
        }
        setLoader(false)
    } else {
        toast.error('Nenhuma nota vinculada para ser salva!')
    }

}

const transferNota = (row, state, setState) => {
    const renamedColumns = {
        id: row.id,
        filial: row.Descricao,
        num_nf: row.NumeroNota,
        emissao: row.DataEmissao,
        chegada: row.DataSaida,
        valor: row.ValorContabil,
        cliente: row.ClienteNFE,
        serie: row.Serie,
        id_cliente: row.CodClientes,
        transportadora: row.TransportadoraNFE,
        id_transportadora: row.CodTransportadores
    }

    const newNotas = state.rowsNotas.filter(item => item.id !== row.id)

    const newNotasVinculadas = [
        ...state.rowsNotasVinculadas.filter(item => item.id !== row.id),
        renamedColumns
    ]

    setState({
        rowsNotasVinculadas: newNotasVinculadas,
        rowsNotas: newNotas
    })
}


const transferNotaVinculada = (row, state, setState) => {
    const renamedColumns = {
        id: row.id,
        Descricao: row.filial,
        NumeroNota: row.num_nf,
        DataEmissao: row.emissao,
        DataSaida: row.chegada,
        ValorContabil: row.valor,
        ClienteNFE: row.cliente,
        Serie: row.serie,
        CodClientes: row.id_cliente,
        TransportadoraNFE: row.transportadora,
        CodTransportadores: row.id_transportadora
    }

    const newNotasVinculadas = state.rowsNotasVinculadas.filter(item => item.id !== row.id)

    const newNotas = [
        ...state.rowsNotas.filter(item => item.id !== row.id),
        renamedColumns
    ]

    setState({
        rowsNotas: newNotas,
        rowsNotasVinculadas: newNotasVinculadas
    })
}



const clearFilter = (state, setState, setLoader, getConhecimentos) => {
    const clearFilters = { rowsConhecimento: state.rowsReset, filialFilter: '', transportadoraFilter: '', numCteFilter: '', statusFilter: '', dtIni: '', dtFim: '', rowsNotas: [] }
    setState(clearFilters)

    getConhecimentos(setLoader, setState, clearFilters)
}

const setInicialDate = (e, setState) => {
    const value = e.format('YYYY-MM-DD')
    setState({ dtIni: value });
}

const setFinalDate = (e, setState) => {
    const value = e.format('YYYY-MM-DD')
    setState({ dtFim: value });
}


const Conhecimentos = () => {

    const currentDate = new Date();
    const threeMonthsAgo = new Date();

    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth());

    threeMonthsAgo.setDate(1);

    const dtIni = convertDateFormat(threeMonthsAgo)
    const dtFim = convertDateFormat(currentDate)

    const [state, setState] = useReducer(lockedReducer, {
        rowsConhecimento: [],
        rowsNotas: [],
        rowsNotasVinculadas: [],
        numConhecimento: '',
        transportadoraCte: '',
        filialFilter: '',
        transportadoraFilter: '',
        numCteFilter: '',
        statusFilter: '2',
        dtIni: dtIni,
        dtFim: dtFim,
        rowsReset: [],

        paginationModel: { page: 0, pageSize: 20 },
        totalConhecimentos: 0,
        next: null

    })

    const [tableConhecimentos] = TableHookPro()

    const [tableNotas] = TableHookPro()

    const [tableNotasVinculadas] = TableHookPro()

    const { loader, setLoader } = useContext(externalComponent)

    const handleRowClick = (params) => {
        // 'params.row' contém os dados da linha clicada
        setState({
            rowsNotas: params.row.notas, numConhecimento: params.row.NumeroNota, rowsNotasVinculadas: params.row.notas_vinculadas,
            transportadoraCte: params.row.ClienteNFE
        })
    };

    useEffect(() => {
        getConhecimentos(setLoader, setState, state)
    }, [])


    return (
        <>
            <Box className='nfsentrada-mainframe' sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', minHeight: '1rem', height: '100%', overflow: 'auto', overflowX: 'hidden' }}>
                <Box className='nfsentrada-filters'>
                    <Box className='filter-items' sx={{ marginBottom: '2rem', alignItems: 'flex-end' }}>

                        <Box className='item-profile-row'>
                            <TextField
                                id="numCteFilter"
                                type="text"
                                label="Núm. CTE"
                                value={state.numCteFilter}
                                onChange={(e) => { setState({ 'numCteFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                                sx={{ width: '9rem' }}
                            />

                        </Box>

                        <Box className='item-profile-row' sx={{ width: '20rem' }} >
                            <MegaAutoComplete

                                id="conhecimentosEmpresa"
                                multiple={false}
                                value={state.filialFilter}
                                onChange={(data) => { setState({ filialFilter: data }) }}
                                noOptionsText={'Digite para procurar uma empresa'}
                                timeoutUrl='/frete/filiais'
                                timeoutParam='label'
                                label='Empresa'
                            />
                        </Box>

                        <Box className='item-profile-row' sx={{ width: '20rem' }} >
                            <MegaAutoComplete

                                id="conhecimentosTransportadora"
                                multiple={false}
                                value={state.transportadoraFilter}
                                onChange={(data) => { setState({ transportadoraFilter: data }) }}
                                noOptionsText={'Digite para procurar uma transportadora'}
                                timeoutUrl='/frete/transportadoras'
                                timeoutParam='label'
                                label='Transportadora'
                            />
                        </Box>

                        <Box className='item-profile-row' sx={{ width: '10rem' }}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Status"
                                    value={state.statusFilter}
                                    onChange={(e) => setState({ 'statusFilter': e.target.value })}
                                >

                                    {
                                        Object.entries(selectStatus).map(([key, value]) => (
                                            <MenuItem key={key} value={value.id}>{value.nome}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </Box>

                        <Box className='item-profile-row' sx={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>

                            <DemoContainer components={['DatePicker']} sx={{ width: '9.5rem', overflow: 'hidden' }}>
                                <DatePicker
                                    label="Dt emissão Inicial:"
                                    size="small"
                                    value={dayjs(state.dtIni)}
                                    onChange={(e) => setInicialDate(e, setState)}
                                    format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    fullWidth
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            InputProps: {
                                                sx: {
                                                    paddingRight: '10px',
                                                    width: '9.5rem',
                                                },
                                            },
                                        },
                                    }}
                                />
                            </DemoContainer>

                            <DemoContainer components={['DatePicker']} sx={{ width: '9.5rem', overflow: 'hidden' }}>
                                <DatePicker
                                    label="Dt emissão Final:"
                                    size="small"
                                    value={dayjs(state.dtFim)}
                                    onChange={(e) => setFinalDate(e, setState)} format='DD/MM/YYYY'
                                    dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            InputProps: {
                                                sx: {
                                                    paddingRight: '10px',
                                                    width: '9.5rem',
                                                },
                                            },
                                        },
                                    }}
                                />
                            </DemoContainer>

                        </Box>

                    </Box>
                    <Box className='filter-buttons'>
                        <ColorButton onClick={() => getConhecimentos(setLoader, setState, state)}>Localizar</ColorButton>
                        <ColorButton onClick={() => clearFilter(state, setState, setLoader, getConhecimentos)}>Limpar filtros</ColorButton>
                    </Box>
                </Box>

                <Box className='tables-container'>
                    <Box className='table-section'>
                        <Typography className='text-bold'>CT-e:</Typography>
                        <Table
                            key='conhecimentos-table-1'
                            paginationMode='server'
                            rowCount={state.totalConhecimentos}
                            paginationModel={state.paginationModel}
                            onPaginationModelChange={(e) =>
                                handlePaginationModelChange(e, setState, getConhecimentos, setLoader, state)
                            }
                            hideFooter={true}
                            className='contabil-grid'
                            rows={state.rowsConhecimento}
                            columns={useMemo(() => getcolumnsConhecimentos())}
                            rowHeight={30}
                            pro={true}
                            onRowClick={handleRowClick}
                            innerRef={tableConhecimentos}
                            nameTable='tableFreteConhecimentos'
                            sx={{
                                '& .MuiDataGrid-row': {
                                    cursor: 'pointer',
                                },
                            }}
                            slots={{
                                columnComponent: true,
                            }}

                            onRowsScrollEnd={() => {
                                if (state.next && !loader) {
                                    const nextOffset = (state.paginationModel.page + 1) * state.paginationModel.pageSize
                                    const nextPage = nextOffset / state.paginationModel.pageSize

                                    getConhecimentos(
                                        setLoader,
                                        setState,
                                        { ...state, paginationModel: { ...state.paginationModel, page: nextPage } },
                                        true
                                    )
                                }
                            }}
                        />


                    </Box>
                    <Box className='table-section'>
                        <Typography className='text-bold'>Notas:</Typography>
                        <Table
                            key='conhecimentos-table-2'
                            paginationMode='client'
                            className='contabil-grid'
                            rows={state.rowsNotas}
                            columns={useMemo(() => getcolumnsNotas(transferNota, state, setState))}
                            rowHeight={30}
                            pro={true}
                            innerRef={tableNotas}
                            nameTable='tableNotasConhecimentos'
                            hideFooter={true}
                        />
                    </Box>
                </Box>

                <Box sx={{ marginTop: '1.5rem' }}>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ColorButton onClick={() => saveConhecimentos(setLoader, setState, state, getConhecimentos)}>Salvar</ColorButton>
                    </Box>

                    <Typography className='text-bold'>Notas Vinculadas ao CT-e:</Typography>
                    <Accordion key='AccordionConhecimentos'>
                        <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '2rem' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
                                        <h6>CT-e: </h6>
                                        <Typography>{state.numConhecimento}</Typography>
                                        <h6>Transportadora:</h6>
                                        <Typography>{state.transportadoraCte}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails className='accordion-content'>
                            <Table
                                key='conhecimentos-table-3'
                                paginationMode='client'
                                className='contabil-grid'
                                rows={state.rowsNotasVinculadas}
                                columns={useMemo(() => getcolumnsNotasVinculadas(transferNotaVinculada, state, setState))}
                                rowHeight={30}
                                pro={true}
                                innerRef={tableNotasVinculadas}
                                nameTable='tableNotasVinculadasConhecimentos'
                                hideFooter={true}
                            />
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Box>
        </>
    )
}

export default Conhecimentos;